import { format, parseISO } from 'date-fns';

import { IppicaCorsaTerminataDto } from 'types/swagger';
import { IppicaUltimiRisultatiCardCompetitor } from '../ippicaUltimiRisultatiCardCompetitor';
import { convertDecimalQuota } from 'features/ippica/functions';
import styles from './IppicaUltimiRisultatiCard.module.scss';

export type IppicaUltimiRisultatiCardProps = {
  item: IppicaCorsaTerminataDto;
  containerClassName?: string;
};

export const IppicaUltimiRisultatiCard = ({ item, containerClassName }: IppicaUltimiRisultatiCardProps) => {
  const date = item?.dataOraAvvenimento ? parseISO(item.dataOraAvvenimento) : new Date();
  const dataFormattata = format(date, 'dd-MM-yyyy');
  const oraFormattata = format(date, 'HH:mm');
  return (
    <article className={`${styles.container} ${containerClassName && containerClassName}`}>
      <div className={styles.textContainer}>
        <p className={styles.smallText}>
          {/* {date} {time} */}
          {dataFormattata} {oraFormattata}
        </p>
        <p className={styles.text}>{item.descrizioneRiunione}</p>
        <span className={styles.chip}>Corsa {item.numeroCorsa}</span>
      </div>
      <div className={styles.list}>
        {item.cavalli &&
          item.cavalli.map((competitor, index) => {
            return (
              <IppicaUltimiRisultatiCardCompetitor
                key={competitor.nomeCavallo + '_' + index}
                quota={competitor.ordineArrivo === 1 ? convertDecimalQuota(competitor?.quote?.[0]?.quota) : ''}
                position={index + 1}
                nomeCavallo={competitor.nomeCavallo}
                nomeFantino={competitor.fantino?.nomeFantino}
                numeroCavallo={competitor.numeroCavallo}
              />
            );
          })}
      </div>
    </article>
  );
};
